export function DpPortalSkeleton() {
    return (
        <div className="space-y-8 pb-12" aria-busy="true" aria-label="Carregando Portal do DP">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                <div className="space-y-3">
                    <div className="h-9 w-64 animate-pulse rounded-lg bg-raro-gray-100" />
                    <div className="h-4 w-96 max-w-full animate-pulse rounded bg-raro-gray-100" />
                </div>
                <div className="h-11 w-96 max-w-full animate-pulse rounded-full bg-raro-gray-100" />
            </div>
            <div className="h-96 animate-pulse rounded-2xl bg-raro-gray-100" />
        </div>
    );
}
